import VanillaTilt from 'vanilla-tilt'
import CONFIG from '@js/config'
import { trackSection } from '@/scripts/ga'
import '@js/app'
import scrollbar from '@js/scrollbar'

import '@page/business/style_field.scss'
import '@page/business/business_cta/bussiness_cta.scss'

import '@comp/animate_title/animate_title'
import '@comp/animate_title/animate_title.scss'

import compCaseCard from '@comp/case_card/case_card.ejs'
import '@comp/case_card/case_card.scss'

import compSmallCard from '@comp/small_card/small_card.ejs'
import '@comp/small_card/small_card.scss'

function fetchList (cb) {
    $.ajax({
        type: 'GET',
        url: `${CONFIG.API_BASE}business`,
        data: {
            page: 1,
            limit: 20,
            type: 'Communicate'
        },
        dataType: 'json',
        success: function (msg) {
            if (msg.message) {
                return cb(new Error(msg.message))
            }

            return cb(null, msg)
        },
        error: function (err) {
            console.log('err', err)
            location.href = '404.html'
        }
    })
}

$(() => {
    trackSection('communicate')

    fetchList(function (err, result) {
        if (err) {
            location.href = '404.html'
            return
        }

        let caseCardHtml = ''
        let relatedList = []

        result.list.forEach(list => {
            let val = compCaseCard({
                title: list.work_company,
                desc: list.title,
                bgUrl: list.cover,
                link: `work.html?id=${list.id}`,
                track: `Work #${list.title}`
            })

            caseCardHtml += `
                <div class="col-md-6 col-sm-6 col-xs-12 slideup case-card-col">
                    ${val}
                </div>
            `
        })

        $('#field-case-list').html(caseCardHtml)

        result.relatedCases.forEach(related => {
            relatedList.push({
                title: related.work_company,
                desc: related.title,
                bgUrl: related.cover,
                link: `work_detail.html?id=${related.id}`,
                track: `Related #${related.title}`
            })
        })

        const relatedCaseHtml = compSmallCard({
            smallCaseList: relatedList
        })
        $('#related-case-list').html(relatedCaseHtml)

        VanillaTilt.init(document.querySelectorAll('.tilt-link'), {
            max: 2,
            speed: 600
        })
    })

    scrollbar.init()
})
